import { Modal } from '@raysee/ui';
import { VFC } from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}
export const SecretPlanDescriptionModal: VFC<Props> = ({ isOpen, onClose }) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <div className="p-4 text-sm">
      <div className="mb-4 border-b pb-2 text-lg font-bold">シークレットメニュー設定について</div>
      <div>
        シークレットメニューを選択すると、そのメニューは通常のユーザーサイト上に表示されず、占い師様が発行したメニューリンクからのみアクセス可能となります。
        <br />
        鑑定中のルーム内や外部サイト等でメニューリンクを直接ユーザーに提示して、限定メニューとしてご利用いただけます。
      </div>
    </div>
  </Modal>
);
